export * from './pagination.module';
export * from './pagination.component';



// WEBPACK FOOTER //
// ./src/app/layout/pagination/index.ts